// src/api/auth.js
import API from "../axiosConfig";

const API_URL = "/whitelist"; // Adjust the base URL as needed

// Fetch all whitelisted vehicles
export const fetchWhitelistedVehicles = async (params) => {
  try {
    const response = await API.get(API_URL, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching whitelisted vehicles:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Add a vehicle to the whitelist
export const addVehicleToWhitelist = async (vehicleData) => {
  try {
    const response = await API.post(API_URL, vehicleData);
    return response.data;
  } catch (error) {
    console.error("Error adding vehicle to whitelist:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Update a vehicle in the whitelist
export const updateWhitelistedVehicle = async (vehicleId, vehicleData) => {
  try {
    const response = await API.put(`${API_URL}/${vehicleId}`, vehicleData);
    return response.data;
  } catch (error) {
    console.error("Error updating whitelisted vehicle:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Delete a vehicle from the whitelist
export const deleteWhitelistedVehicle = async (vehicleId) => {
  try {
    const response = await API.delete(`${API_URL}/${vehicleId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting whitelisted vehicle:", error);
    throw error; // Rethrow error to be handled in the component
  }
};

// Fetch only trashed/deleted whitelisted vehicles
export const fetchTrashedWhitelistedVehicles = async (params) => {
  try {
    const response = await API.get(`${API_URL}-only-trashed`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching trashed whitelisted vehicles:", error);
    throw error; // Rethrow error to be handled in the component
  }
};
